import React, { useState, useContext } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { Checkbox } from '../../shared/button'
import { StateContext } from '../../../state'
import styles from './settings-panel.css'

const SettingOption = ({
  option, isActive, onClick, setDisable, showQualityUpgradePopup
}) => {
  const [transition, setTransition] = useState(false)
  const { purchasedFormat, svodStreamingResolution, isTrailer } = useContext(StateContext)

  const handleClick = () => {
    if (svodStreamingResolution === 'SD') {
      // Show Upgrade Popup Message
      showQualityUpgradePopup(true)
    } else {
      if (isActive) return
      // prevent user from click on the table again.
      setDisable(true)
      setTransition(true)
      // kick off animation and animation last 500ms
      setTimeout(() => {
        setTransition(false)
        onClick()
      }, 500)
    }
  }

  return (
    <tr
      className={classnames(styles.row, {
        [styles.active]: transition,
        [styles.greyOut]: option.label === 'HD' && svodStreamingResolution === 'SD' && !isTrailer,
        [styles.optionDisabled]: option.label === 'HD' && purchasedFormat === 'SD' && !isTrailer
      })}
      onClick={handleClick}
    >
      <td className={styles.checkBoxCell}>
        <Checkbox isChecked={isActive} />
      </td>
      <td className={styles.label}>{option.label}</td>
      <td className={styles.description}>{option.description}</td>
    </tr>
  )
}

SettingOption.propTypes = {
  option: PropTypes.shape({
    bitrate: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  setDisable: PropTypes.func.isRequired,
  showQualityUpgradePopup: PropTypes.func
}

export default SettingOption
